import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export const useGetWeekPlannerCapacity = (params) => {
    const intl = useIntl();
    const { data, isLoading, error, refetch } = useQuery([TaskQueryKey.WeekPlannerCapacity, params.userId, params.from], () => api.base
        .get(`${config.appUrls.api}/api/registration/WeekPlannerCapacity`, {
        params,
    })
        .then(res => res.data), {
        enabled: !!params.userId && !!params.from && !!params.to,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return {
        data,
        error,
        isLoading,
        refetch,
    };
};
